import MyBread from '../../components/Breadcrumbs'
import React, { Fragment, useEffect, useState, Dispatch, SetStateAction } from 'react'
import MaterialTable from 'material-table'
import { ThemeProvider, createTheme, TableBody, TableCell, TableRow, CircularProgress } from '@mui/material';
import { useModal } from 'react-hooks-use-modal';
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from '../../hooks/use-auth';
import axios from 'axios';
import IdSearchButtonWithParent from '../../components/IdSearchButtonWithParent';
import IdSearchButton from '../../components/IdSearchButton';
import config from 'config';
import { removeKeyWithValue } from 'utils';
import { DeletedContents } from 'styles/styles';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { Edit, Delete } from '@mui/icons-material';
import { Wrapper, PageTitle, CreateNew, ModalStyle, FormLabel, FormInput, FormLabelInputWrapper, ModalTitle, ModalForm, ModalSubmit, LoadingContainer, ModalClose, DivMargin } from 'styles/styles';

interface ParentProps {
  data: ParentDataProps[];
  selectedId: number;
  setSelectedId: Dispatch<SetStateAction<number>>;
  setIsParentDataInsert: Dispatch<SetStateAction<boolean>>;
}

interface SetDataProps {
  (data: ChildDataProps[]): void;
}

interface ChildProps {
  data: ChildDataProps[];
  setData: SetDataProps;
  setIsChildDataInsert: Dispatch<SetStateAction<boolean>>;
  selectedId: number;
}

interface ParentDataProps {
  standard_process_id: number
  product_number_branch_id: number
  display_id: string
  memo: string
  [key: string]: string | number;
}

interface ChildDataProps {
  standard_process_branch_id: number;
  process_id: string;
  equipment_id: string;
  number: number;
  setup_time: string;
  tact_time: string;
  tableData: {
    id: number;
  };
  [key: string]: string | number | { id: number };
}

const Parent = ({ data, selectedId, setSelectedId, setIsParentDataInsert }: ParentProps) => {
  const auth = useAuth();
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  //modal
  const [modalTitle, setModalTitle] = React.useState('');
  const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
  const { reset, register, handleSubmit, setValue, watch, formState: { errors } } = useForm<ParentDataProps>();
  const onSubmit: SubmitHandler<ParentDataProps> = async (submitData: ParentDataProps) => {
    let alertList: any[] = [];
    const requiredFields = parentArray.filter(obj => obj.required === true).map(obj => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined || submitData[key] === '') {
        alertList.push(key)
      }
    });
    if (alertList.length) {
      let text = '';
      parentArray.forEach(item => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== '') {
        alert(text);
        throw new Error('必須項目が未入力です');
      }
    }
    submitData = removeKeyWithValue(submitData, '');
    const branchData = {
      display_id: submitData.display_id,
      memo: submitData.memo,
    }
    try {
      setIsSubmitDisable(true);
      if (!selectedId) {
        await axios.post(`/v0/product_number_branches/${submitData.product_number_branch_id}/standard-processes`, branchData, {
          headers: auth.authorizationHeader,
          params: { factory_id: auth.factoryId }
        });
        window.alert("登録が完了しました");
      } else {
        await axios.patch(`/v0/product_number_branches/${submitData.product_number_branch_id}/standard-processes`, branchData, {
          headers: auth.authorizationHeader,
          params: {
            selected_branch: selectedId,
            factory_id: auth.factoryId
          }
        });
        window.alert("変更が完了しました");
      }
      close();
      setIsParentDataInsert(true);
    } catch (error: any) {
      window.alert(error.response.data.error);
    }
    setIsSubmitDisable(false);
  };
  //modal end

  //arrayの生成
  const parentArray = [{ title: '', field: 'standard_process_id' },
  { title: '', field: 'product_number_id' },
  { title: '品番ID', field: 'product_number_display_id', default: '', required: true, disable: true },
  { title: '', field: 'product_number_branch_id' },
  { title: '品番_枝番', field: 'product_number_branch_display_id', default: '', required: true, disable: true },
  { title: '品名', field: 'product_number_branch_name', default: '', search: 'product-numbers', required: true, disable: true },
  { title: '標準工程枝番', field: 'display_id', default: '00', type: 'branch', required: true },
  { title: 'メモ', field: 'memo', default: 'メモです', type: 'text' }]
  const PAGE_TITLE = "標準工程"
  const defaultObj: any = {};
  for (const element of parentArray) {
    defaultObj[element.field] = element.default;
  }
  const columnsArray: any = [];
  for (const element of parentArray) {
    if (element.title) {
      columnsArray.push({
        title: element.title,
        field: element.field,
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      })
    }
  }

  const [selectedProductNumberContents, setSelectedProductNumberContents] = useState<any>('');
  const [selectedProductNumberBranchContents, setSelectedProductNumberBranchContents] = useState<any>('');

  useEffect(() => {
    setValue('product_number_id', selectedProductNumberContents.product_number_id);
    setValue('product_number_display_id', selectedProductNumberContents.display_id);
    setValue('product_number_branch_id', selectedProductNumberBranchContents.product_number_branch_id);
    setValue('product_number_branch_display_id', selectedProductNumberBranchContents.display_id);
    setValue('product_number_branch_name', selectedProductNumberBranchContents.name);
  }, [selectedProductNumberContents, selectedProductNumberBranchContents])

  const listItems = parentArray.map((element: any, index) => {
    if (element.title) {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            <FormInput {...register(element.field)}
              {...(element.type && { type: config.inputErrorMessage[element.type].type })}
              {...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
              {...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
              {...(element.type && { title: config.inputErrorMessage[element.type].title })}
              {...(element.required && { required: true })}
              {...(element.disable && { disabled: true })}
              {...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
              {...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
            />
            {element.search === "product-numbers" ? <IdSearchButtonWithParent search={element.search} setSelectedContents={setSelectedProductNumberContents} setSelectedBranchContents={setSelectedProductNumberBranchContents} /> : <></>}
          </FormLabelInputWrapper>
        </Fragment>
      )
    }
  }
  );

  //カラムなど生成ここまで

  const [pageSize, setPageSize] = React.useState(5);
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);

  //IDから既存の値を呼び出し
  // ここでは、品番枝番IDをつけいため、渡している。
  async function setModalValue(product_number_branch_id: number, standard_process_id: number) {
    if (!standard_process_id) {
      setSelectedId(0);
      reset(defaultObj);
      setModalTitle("新規作成")
    } else {
      //データの取得axios
      setSelectedId(standard_process_id);
      const result: any = await axios.get(`/v0/product_number_branches/${product_number_branch_id}/standard-processes`, {
        headers: auth.authorizationHeader,
        params: {
          selected_branch: standard_process_id,
          factory_id: auth.factoryId
        }
      });
      reset(result.data[0]);
      setModalTitle("編集")
    }
  }

  const createNew = async () => {
    await setModalValue(0, 0);
    open();
  }

  return (
    <>
      <CreateNew onClick={createNew}>新規作成</CreateNew>
      <ThemeProvider theme={defaultMaterialTheme}>
        <MaterialTable
          title={PAGE_TITLE}
          columns={columnsArray}
          data={data}
          actions={[
            {
              icon: 'edit',
              tooltip: '編集する',
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                try {
                  await setModalValue(rowData.product_number_branch_id, rowData.standard_process_id);
                  open();
                } catch (error) {
                  console.log(error)
                }
              }
            },
            {
              icon: 'delete',
              tooltip: '削除する',
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                const result = window.confirm(`${rowData.display_id}を削除しますか？`);
                if (result) {
                  try {
                    await axios.delete(`/v0/product_number_branches/${rowData.product_number_branch_id}/standard-processes`, {
                      headers: auth.authorizationHeader,
                      params: {
                        selected_branch: rowData.standard_process_id,
                        factory_id: auth.factoryId
                      }
                    });
                    setSelectedId(0);
                    setIsParentDataInsert(true);
                  } catch (error: any) {
                    window.alert(error.response.data.error);
                  }
                }
              }
            }
          ]}
          options={{
            actionsColumnIndex: -1,
            draggable: false,
            headerStyle: { whiteSpace: 'nowrap' },
            rowStyle: (rowData) => ({
              overflowWrap: 'break-word',
              backgroundColor: selectedRow === rowData.tableData.id ? '#EEE' : '#FFF',
            })
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onRowClick={(event: any, rowData: any) => {
            event.preventDefault();
            setSelectedId(rowData.standard_process_id);
            setSelectedRow(rowData.tableData.id);
          }}
        />
      </ThemeProvider>

      <Modal>
        <ModalStyle>
          <ModalTitle>{modalTitle}</ModalTitle>
          <ModalForm onSubmit={handleSubmit(onSubmit)}>
            {listItems}
            {isSubmitDisable ? (
              <LoadingContainer>
                <CircularProgress size={20} />
              </LoadingContainer>
            ) : (
              <ModalSubmit type="submit" disabled={isSubmitDisable} />
            )}
          </ModalForm>
          <ModalClose onClick={close}>CLOSE</ModalClose>
        </ModalStyle>
      </Modal>
    </>
  )
}

const Child = ({ data, setData, setIsChildDataInsert, selectedId }: ChildProps) => {
  const auth = useAuth();
  const [selectedBranch, setSelectedBranch] = React.useState(0);
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  //modal
  const [pageSize, setPageSize] = React.useState(5);
  const [modalTitle, setModalTitle] = React.useState('');
  const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
  const { reset, register, handleSubmit, setValue, watch, formState: { errors } } = useForm<ChildDataProps>();
  const onSubmit: SubmitHandler<ChildDataProps> = async (submitData: ChildDataProps) => {
    let alertList: any[] = [];
    const requiredFields = parentArray.filter(obj => obj.required === true).map(obj => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined || submitData[key] === '') {
        alertList.push(key)
      }
    });
    if (alertList.length) {
      let text = '';
      parentArray.forEach(item => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== '') {
        alert(text);
        throw new Error('必須項目が未入力です');
      }
    }
    submitData = removeKeyWithValue(submitData, '');
    const branchData = {
      process_id: submitData.process_id,
      equipment_id: submitData.equipment_id,
      number: submitData.number,
      setup_time: submitData.setup_time,
      tact_time: submitData.tact_time,
    }
    try {
      setIsSubmitDisable(true);
      if (!selectedBranch) {
        await axios.post(`/v0/standard-processes/${selectedId}/branches`, branchData, {
          headers: auth.authorizationHeader,
          params: { factory_id: auth.factoryId }
        })
        window.alert("登録が完了しました");
      } else {
        await axios.patch(`/v0/standard-processes/${selectedId}/branches`, branchData, {
          headers: auth.authorizationHeader,
          params: {
            selected_branch: selectedBranch,
            factory_id: auth.factoryId
          }
        })
        window.alert("変更が完了しました");
      }
      close();
      setIsChildDataInsert(true);
    } catch (error: any) {
      window.alert(error.response.data.error);
    }
    setIsSubmitDisable(false);
  };
  //modal end

  //arrayの生成
  const parentArray = [{ title: '', field: 'standard_process_branch_id' },
  { title: '', field: 'process_id' },
  { title: '', field: 'process_is_deleted' },
  { title: '順番', default: '', field: 'number' },
  { title: '工程ID', field: 'process_display_id', default: '', required: true, disable: true },
  { title: '工程名称', field: 'process_name', default: '', search: 'processes', required: true, disable: true },
  { title: '', field: 'equipment_id' },
  { title: '', field: 'equipment_is_deleted' },
  { title: '設備ID', field: 'equipment_display_id', default: '', disable: true },
  { title: '設備名称', field: 'equipment_name', default: '', search: 'equipments', disable: true },
  { title: '段取時間(分)', field: 'setup_time', default: 0, type: 'number', required: true },
  { title: 'タクトタイム(分)', field: 'tact_time', default: 0, type: 'number', required: true },
  { title: 'Actions', field: 'actions', }
  ]
  const PAGE_TITLE = "標準工程一覧"
  const defaultObj: any = {};
  for (const element of parentArray) {
    defaultObj[element.field] = element.default;
  }
  const columnsArray: any = [];


  for (const element of parentArray) {
    if (element.title) {
      columnsArray.push({
        title: element.title,
        field: element.field,
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      })
    }
  }

  const [selectedProcessContents, setSelectedProcessContents] = useState<any>('');

  useEffect(() => {
    setValue('process_id', selectedProcessContents.process_id);
    setValue('process_display_id', selectedProcessContents.display_id);
    setValue('process_name', selectedProcessContents.name);
    setValue('equipment_id', selectedProcessContents.equipment_id);
    setValue('equipment_display_id', selectedProcessContents.equipment_display_id);
    setValue('equipment_name', selectedProcessContents.equipment_name);
  }, [selectedProcessContents])


  const [selectedEquipmentContents, setSelectedEquipmentContents] = useState<any>('');

  useEffect(() => {
    setValue('equipment_id', selectedEquipmentContents.equipment_id);
    setValue('equipment_display_id', selectedEquipmentContents.display_id);
    setValue('equipment_name', selectedEquipmentContents.name);
  }, [selectedEquipmentContents])

  const listItems = parentArray.map((element: any, index) => {
    if (element.title && element.field !== "actions" && element.field !== "number") {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            <FormInput {...register(element.field)}
              {...(element.type && { type: config.inputErrorMessage[element.type].type })}
              {...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
              {...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
              {...(element.type && { title: config.inputErrorMessage[element.type].title })}
              {...(element.required && { required: true })}
              {...(element.disable && { disabled: true })}
              {...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
              {...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
            />
            {element.search === "processes" ? <IdSearchButton search={element.search} setSelectedContents={setSelectedProcessContents} /> :
              element.search === "equipments" ? <IdSearchButton search={element.search} setSelectedContents={setSelectedEquipmentContents} /> : <></>}
          </FormLabelInputWrapper>
        </Fragment>
      )
    }
  }
  );
  //カラムなど生成ここまで

  const defaultMaterialTheme = createTheme();

  //IDから既存の値を呼び出し
  async function setModalValue(standard_process_branch_id: number) {
    if (!standard_process_branch_id) {
      setSelectedBranch(0);
      reset(defaultObj);
      setModalTitle("新規作成")
    } else {
      //データの取得axios
      setSelectedBranch(standard_process_branch_id);
      const result: any = await axios.get(`/v0/standard-processes/${selectedId}/branches`, {
        headers: auth.authorizationHeader,
        params: {
          selected_branch: standard_process_branch_id,
          factory_id: auth.factoryId
        }
      });
      reset(result.data[0]);
      setModalTitle("編集")
    }
  }

  const createNew = async () => {
    await setModalValue(0);
    open();
  }

  const handleDragEnd = async (result: any) => {
    if (!result.destination) return;
    const items = Array.from(data);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    const output = items.map((item, index) => ({
      id: item.standard_process_branch_id,
      number: index + 1
    }));
    const branchData = {
      data: output
    }
    try {
      await axios.patch(`/v0/standard-processes/${selectedId}/update-numbers`, branchData, {
        headers: auth.authorizationHeader,
        params: {
          factory_id: auth.factoryId
        }
      })
      setData(items);
    } catch (error: any) {
      window.alert(error.response.data.error);
    }
  };

  const handleEditClick = async (event: any, rowData: any) => {
    event.preventDefault();
    try {
      await setModalValue(rowData.standard_process_branch_id);
      open();
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteClick = async (event: any, rowData: any) => {
    event.preventDefault();
    const result = window.confirm(`${rowData.process_display_id}を削除しますか？`);
    if (result) {
      try {
        await axios.delete(`/v0/standard-processes/${selectedId}/branches`, {
          headers: auth.authorizationHeader,
          params: {
            selected_branch: rowData.standard_process_branch_id,
            factory_id: auth.factoryId
          }
        })
        setIsChildDataInsert(true);
      } catch (error: any) {
        window.alert(error.response.data.error);
      }
    }
  };

  function isConditionSatisfied(rowData: any, type: string): boolean {
    return (
      (rowData.process_is_deleted && type === "process") ||
      (rowData.equipment_is_deleted && type === "equipment")
    );
  }

  const renderRow = (row: any, index: number) => {
    return (
      <Draggable key={row.standard_process_branch_id.toString()} draggableId={row.standard_process_branch_id.toString()} index={index}>
        {(provided) => (
          <TableRow
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <TableCell style={tableCell}>{index + 1}</TableCell>
            {isConditionSatisfied(row, "process") ? <TableCell style={tableCell}><DeletedContents>{row.process_display_id}</DeletedContents></TableCell> : <TableCell style={tableCell}>{row.process_display_id}</TableCell>}
            {isConditionSatisfied(row, "process") ? <TableCell style={tableCell}><DeletedContents>{row.process_name}</DeletedContents></TableCell> : <TableCell style={tableCell}>{row.process_name}</TableCell>}
            {isConditionSatisfied(row, "equipment") ? <TableCell style={tableCell}><DeletedContents>{row.equipment_display_id}</DeletedContents></TableCell> : <TableCell style={tableCell}>{row.equipment_display_id}</TableCell>}
            {isConditionSatisfied(row, "equipment") ? <TableCell style={tableCell}><DeletedContents>{row.equipment_name}</DeletedContents></TableCell> : <TableCell style={tableCell}>{row.equipment_name}</TableCell>}
            <TableCell style={tableCell}>{row.setup_time}</TableCell>
            <TableCell style={tableCell}>{row.tact_time}</TableCell>
            <TableCell style={tableCell}><Edit onClick={(event) => handleEditClick(event, row)} /><Delete onClick={(event) => handleDeleteClick(event, row)} /></TableCell>
          </TableRow>
        )}
      </Draggable>
    );
  };

  const renderTableBody = () => {
    return (
      <Droppable droppableId="droppable">
        {(provided) => (
          <TableBody ref={provided.innerRef} {...provided.droppableProps}>
            {data.map((row, index) => renderRow(row, index))}
            {provided.placeholder}
          </TableBody>
        )}
      </Droppable>
    );
  };

  return (
    <>
      {selectedId === 0 ? "" : <><CreateNew onClick={createNew}>新規作成</CreateNew></>}
      <ThemeProvider theme={defaultMaterialTheme}>
        <DragDropContext onDragEnd={handleDragEnd}>
          <MaterialTable
            title={PAGE_TITLE}
            columns={columnsArray}
            data={data}
            options={{
              actionsColumnIndex: -1,
              paging: false,
              draggable: false,
              search: false,
              sorting: false,
              headerStyle: { whiteSpace: 'nowrap' },
              rowStyle: { overflowWrap: 'break-word' }
            }}
            components={{
              Body: () => renderTableBody(),
            }}
          />
        </DragDropContext>
      </ThemeProvider>

      <Modal>
        <ModalStyle>
          <ModalTitle>{modalTitle}</ModalTitle>
          <ModalForm onSubmit={handleSubmit(onSubmit)}>
            {listItems}
            {isSubmitDisable ? (
              <LoadingContainer>
                <CircularProgress size={20} />
              </LoadingContainer>
            ) : (
              <ModalSubmit type="submit" disabled={isSubmitDisable} />
            )}
          </ModalForm>
          <ModalClose onClick={close}>CLOSE</ModalClose>
        </ModalStyle>
      </Modal>
    </>
  )
}

export default function StandardProcesses() {
  const auth = useAuth();
  const [isParentDataInsert, setIsParentDataInsert] = useState<boolean>(false);
  const [isChildDataInsert, setIsChildDataInsert] = useState<boolean>(false);
  const [parentData, setParentData] = useState<ParentDataProps[]>([]);
  const [childData, setChildData] = useState<ChildDataProps[]>([]);
  const [selectedId, setSelectedId] = useState<number>(0);

  useEffect(() => {
    try {
      axios.get(`/v0/factories/${auth.factoryId}/standard-processes`, {
        headers: auth.authorizationHeader
      }).then((res: any) => {
        if (res.data.length) {
          setParentData(res.data);
        } else {
          setParentData([]);
        }
        setIsParentDataInsert(false)
      })
    } catch (err) {
      console.log(err)
    }
  }, [auth, isParentDataInsert]);

  useEffect(() => {
    if (!selectedId) {
      setChildData([]);
    } else {
      try {
        axios.get(`/v0/standard-processes/${selectedId}/branches`, {
          headers: auth.authorizationHeader,
          params: {
            factory_id: auth.factoryId
          }
        }).then((res: any) => {
          if (res.data.length) {
            setChildData(res.data)
          } else {
            setChildData([]);
          }
          setIsChildDataInsert(false)
        })
      } catch (err) {
        console.log(err)
      }
    }
  }, [auth, selectedId, isChildDataInsert])

  return (
    <>
      <Wrapper>
        <MyBread />
        <PageTitle>標準工程マスタ</PageTitle>
        <Parent data={parentData} selectedId={selectedId} setSelectedId={setSelectedId} setIsParentDataInsert={setIsParentDataInsert} />
        <DivMargin></DivMargin>
        <Child data={childData} setData={setChildData} selectedId={selectedId} setIsChildDataInsert={setIsChildDataInsert} />
      </Wrapper>
    </>
  )
}

const tableCell = {
  maxWidth: '150px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap' as 'nowrap',
};